import React, { useState } from "react";
import { View, Image, Text, StyleSheet, TouchableOpacity } from "react-native";
import photo from "../assests/Bannerfinal.png";

const IntroScreen = ({ navigation }) => {
  const [uri, setUri] = useState(photo);
  return (
    <>
      <View style={styles.container}>
        <Image source={uri} style={styles.image} />

        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Home")}
        >
          <Text style={styles.text}>Let's Practice!!</Text>
        </TouchableOpacity>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    backgroundColor: "#F4CE6A",
  },
  button: {
    alignItems: "center",
    borderColor: "black",
    borderWidth: 4,
    borderColor: "white",
    borderRadius: 180,
    padding: 10,
    marginVertical: 10,
  },
  text: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 15,
    color: "white",
  },
  image: {
    width: 350,
    height: 600,
  },
});

export default IntroScreen;
